(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 4819:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function ChevronDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 7992:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 1595:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/articles/[slug]",
      function () {
        return __webpack_require__(4768);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function BlogArticleLabels(param) {
    var title = param.title, estimate = param.estimate, date = param.date;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "info mb-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "px-2 text-white bg-gray-400 text-[10px] uppercase inline-block rounded-lg",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "py-1 pl-4 pr-2 text-gray-600 text-xs inline-block",
                children: [
                    estimate,
                    " mins read"
                ]
            }),
            "•",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "py-1 pl-2 text-gray-600 text-xs inline-block ",
                children: date
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BlogArticleLabels);


/***/ }),

/***/ 2508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



function BlogCategoryList(param) {
    var selected = param.selected, categories = param.categories;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col relative w-full mb-4 order-3 lg:order-none",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "flex !text-[1rem] font-bold uppercase mb-4 !mt-0",
                    children: "Categories"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    className: "flex flex-col list-none border-b border-gray-100",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "!list-none !mx-0 !p-0",
                            children: [
                                selected === "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "block p-4 border-t border-gray-100 w-full bg-gray-100 text-trust",
                                    children: "All categories"
                                }),
                                selected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/blog/1",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "block p-4 border-t border-gray-100 w-full hover:bg-gray-100",
                                        children: "All categories"
                                    })
                                })
                            ]
                        }, "blog-category-all"),
                        categories.map(function(cat) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                className: "!list-none !mx-0 !p-0",
                                children: [
                                    selected === cat.slug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "block p-4 border-t border-gray-100 w-full bg-gray-100 text-trust",
                                        children: [
                                            cat.title,
                                            "  (",
                                            cat.articleCount,
                                            ")"
                                        ]
                                    }),
                                    selected !== cat.slug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: "/blog/categories/".concat(cat.slug, "/1"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: "block p-4 border-t border-gray-100 w-full hover:bg-gray-100",
                                            children: [
                                                cat.title,
                                                " (",
                                                cat.articleCount,
                                                ")"
                                            ]
                                        })
                                    })
                                ]
                            }, "blog-category-".concat(cat.id));
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BlogCategoryList);


/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeroSubpage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _photo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4761);


function HeroSubpage(props) {
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "header-subpage relative ".concat(props.headerCss ? props.headerCss : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative subpage-gradient w-full",
                    children: ((ref = props.image) === null || ref === void 0 ? void 0 : ref.data) ? props.imageAsBackground ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute z-1 top-0 w-full h-full opacity-50 bg-blend-soft-light bg-no-repeat bg-cover bg-center",
                                style: {
                                    backgroundImage: "url(".concat(props.image.data.attributes.url, ")")
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container py-[12rem] relative z-2 ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center justify-start ",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex flex-col w-full p-10 md:w-2/3 text-white justify-start ".concat(props.contentCss ? props.contentCss : ""),
                                        dangerouslySetInnerHTML: {
                                            __html: props.content
                                        }
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-start py-[10rem]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex w-2/5 mx-auto md:w-1/2 relative z-20 pl-8 justify-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_photo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        image: props.image
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex flex-col w-full p-8 pt-0 md:w-2/3 text-white justify-start",
                                    dangerouslySetInnerHTML: {
                                        __html: props.content
                                    }
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center justify-start pt-[6rem] pb-[6rem]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col w-full p-10 ".concat(!props.full ? "md:w-2/3" : "", " text-white justify-start"),
                                dangerouslySetInnerHTML: {
                                    __html: props.content
                                }
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "skew-bottom"
                })
            ]
        })
    });
}


/***/ }),

/***/ 8326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_share__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1818);



function ShareIcons(param) {
    var title = param.title, body = param.body, url = param.url;
    var shareUrl = "".concat("https://www.arka-parcel-lockers.com").concat(url);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .FacebookShareButton */ .Dk, {
                url: shareUrl,
                quote: body,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .FacebookIcon */ .Vq, {
                    bgStyle: {
                        fill: "#fff"
                    },
                    iconFillColor: "#ccc",
                    size: 32,
                    round: true,
                    className: "mr-2 mb-2 border border-gray-300 rounded-[50px]"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .TwitterShareButton */ .B, {
                url: shareUrl,
                title: title,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .TwitterIcon */ .Zm, {
                    bgStyle: {
                        fill: "#fff"
                    },
                    iconFillColor: "#ccc",
                    size: 32,
                    round: true,
                    className: "mr-2 mb-2 border border-gray-300 rounded-[50px]"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .LinkedinShareButton */ .r2, {
                url: shareUrl,
                title: title,
                summary: body,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .LinkedinIcon */ .pA, {
                    bgStyle: {
                        fill: "#fff"
                    },
                    iconFillColor: "#ccc",
                    size: 32,
                    round: true,
                    className: "mr-2 mb-2 border border-gray-300 rounded-[50px]"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .TumblrShareButton */ .SZ, {
                url: shareUrl,
                title: title,
                caption: body,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .TumblrIcon */ .OA, {
                    bgStyle: {
                        fill: "#fff"
                    },
                    iconFillColor: "#ccc",
                    size: 32,
                    round: true,
                    className: "mr-2 mb-2 border border-gray-300 rounded-[50px]"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .RedditShareButton */ .iR, {
                url: shareUrl,
                title: title,
                windowWidth: 660,
                windowHeight: 460,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .RedditIcon */ .MP, {
                    bgStyle: {
                        fill: "#fff"
                    },
                    iconFillColor: "#ccc",
                    size: 32,
                    round: true,
                    className: " mb-2 border border-gray-300 rounded-[50px]"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ShareIcons);


/***/ }),

/***/ 4994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$U": function() { return /* binding */ Merge; }
/* harmony export */ });
/* unused harmony exports estimateTime, formatDate, uniqueArray, sortObjectByKey, getFirstLastName, replaceValuesInString, setEmailVars, nextGivenDay */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2222);



function Merge(glob, page) {
    var newObj = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, glob);
    for(var key in page){
        if (typeof page[key] === "object") {
            if (key === "metaImage") {
                if (page[key].data !== null) {
                    newObj[key] = page[key];
                }
            } else if (key === "metaSocial") {
                if (page[key].length > 0) {
                    newObj[key] = page[key];
                }
            } else {
                newObj[key] = page[key];
            }
        } else if ((0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(page[key]) === "array") {
            if (page[key].length) {
                newObj[key] = page[key];
            }
        } else {
            if (page[key]) {
                newObj[key] = page[key];
            }
        }
    }
    return newObj;
}
var estimateTime = function(content) {
    var text = content.replace(/(<([^>]+)>)/gi, "");
    var words = text.split(" ");
    return Math.ceil(words.length / 200);
};
var formatDate = function(date) {
    var newDate = new Date(date);
    return newDate.toLocaleDateString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric"
    });
};
var uniqueArray = function(arrayData) {
    return arrayData.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
};
var sortObjectByKey = function(list, key) {
    var subKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, order = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "asc";
    if (subKey) {
        if (order === "asc") {
            return list.sort(function(a, b) {
                return a[key][subKey] > b[key][subKey] ? 1 : b[key][subKey] > a[key][subKey] ? -1 : 0;
            });
        } else {
            return list.sort(function(a, b) {
                return a[key][subKey] < b[key][subKey] ? 1 : b[key][subKey] < a[key][subKey] ? -1 : 0;
            });
        }
    } else {
        if (order === "asc") {
            return list.sort(function(a, b) {
                return a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0;
            });
        } else {
            return list.sort(function(a, b) {
                return a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0;
            });
        }
    }
};
var getFirstLastName = function() {
    var fullName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var name = fullName.trim();
    if (!name.length) {
        return {
            firstname: "",
            lastname: ""
        };
    }
    var splitName = name.split(" ");
    var firstName = splitName[0];
    var lastName = splitName.length > 1 ? splitName[splitName.length - 1] : "";
    return {
        firstname: firstName,
        lastname: lastName
    };
};
var defaultReplaceMap = {
    "[[[": "{{{",
    "]]]": "}}}",
    "[[": "{{",
    "]]": "}}"
};
var replaceValuesInString = function(str) {
    var replaceMap = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultReplaceMap;
    var pattern, replacer;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(replaceMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _sliced_to_array(_step.value, 2), key = _value[0], value = _value[1];
            pattern = new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g");
            replacer = value;
            str = str.replace(pattern, replacer);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return str;
};
var setEmailVars = function(text) {
    return text.replace(/\[\[\[/g, "{{{").replace(/\]\]\]/g, "}}}").replace(/\[\[/g, "{{").replace(/\]\]/g, "}}");
};
var nextGivenDay = function(day, hour) {
    var toISO = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    var today = new Date();
    var targetDay = today.getDay();
    while(daysOfWeek[targetDay] !== day){
        targetDay = (targetDay + 1) % 7;
    }
    var nextDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (targetDay + 7 - today.getDay()) % 7);
    nextDate.setHours(hour);
    if (nextDate <= today) {
        nextDate.setDate(nextDate.getDate() + 7);
    }
    if (toISO) {
        return nextDate.toISOString();
    } else {
        nextDate;
    }
};


/***/ }),

/***/ 4768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/blog-category-list.jsx
var blog_category_list = __webpack_require__(2508);
// EXTERNAL MODULE: ./components/hero-subpage.jsx
var hero_subpage = __webpack_require__(5467);
// EXTERNAL MODULE: ./components/layout.jsx + 5 modules
var layout = __webpack_require__(5726);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/blog-article-suggestion.jsx




function BlogArticleSuggestion(param) {
    var direction = param.direction, article = param.article;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/blog/articles/".concat(article.slug),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "flex flex-row flex-grow h-32 btn trust-border mb-4 mx-2 lg:mx-0 w-full sm:max-w-[45%] sm:w-auto lg:max-w-none lg:flex-grow-0 lg:w-full relative rounded-lg overflow-hidden opacity-100 lg:opacity-50 hover:opacity-100",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex absolute z-20 top-0 flex-row p-4 w-full h-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-1/5 items-center justify-center ".concat(direction === "right" ? "order-2" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "text-maturity-500 text-[2rem] flaticon-".concat(direction, "-arrow")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-4/5 items-start justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "text-sm normal-case ",
                                children: article.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-xxs text-maturity-300",
                                children: [
                                    article.estimate,
                                    " mins read"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var blog_article_suggestion = (BlogArticleSuggestion);

// EXTERNAL MODULE: ./lib/seo-context.js
var seo_context = __webpack_require__(4449);
// EXTERNAL MODULE: ./lib/helper.js
var helper = __webpack_require__(4994);
// EXTERNAL MODULE: ./components/blog-article-labels.jsx
var blog_article_labels = __webpack_require__(3587);
// EXTERNAL MODULE: ./components/share-icons.jsx
var share_icons = __webpack_require__(8326);
;// CONCATENATED MODULE: ./pages/blog/articles/[slug].jsx











function Article(props) {
    var pageProps = props.pageProps, global = props.global;
    if (!pageProps) return;
    var nextArticle = pageProps.nextArticle ? pageProps.nextArticle : null;
    var prevArticle = pageProps.prevArticle ? pageProps.prevArticle : null;
    var categories = pageProps.categories ? pageProps.categories : null;
    var article = pageProps;
    var seo = pageProps && pageProps.seo ? (0,helper/* Merge */.$U)(global.seo, pageProps.seo) : global.seo;
    seo.canonicalURL = "".concat("https://www.arka-parcel-lockers.com", "/blog/articles/").concat(pageProps.slug);
    seo.type = "article";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(seo_context/* default.Provider */.Z.Provider, {
        value: seo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
            footerClass: "skew-maturity-100",
            languageData: {
                originalSlug: pageProps.originalSlug,
                languages: pageProps.localizations
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_subpage/* default */.Z, {
                    content: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "container max-w-screen-xl mx-auto pt-10 relative z-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col lg:flex-row px-10 xl:px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col w-full lg:w-2/3 relative",
                                children: article && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "text-[2rem] text-trust-500",
                                                children: article.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_article_labels/* default */.Z, {
                                                title: article.blog_category.data.attributes.title,
                                                estimate: article.estimate,
                                                date: article.date
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative flex w-full aspect-video mb-4 rounded-md overflow-hidden",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    layout: "fill",
                                                    src: article.image.data.attributes.url,
                                                    alt: article.image.data.attributes.alternativeText,
                                                    priority: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col md:flex-row relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex flex-col pr-4 md:pb-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "share-icons sticky top-32 pt-2",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_icons/* default */.Z, {
                                                                title: article.title,
                                                                url: "/blog/articles/".concat(article.slug),
                                                                body: article.summary
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex flex-col flex-grow pb-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: article.content
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row flex-wrap w-full lg:flex-col lg:w-1/3 lg:pl-10 lg:mt-20 relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row lg:flex-col flex-wrap sticky top-32 w-full",
                                    children: [
                                        categories && /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_category_list/* default */.Z, {
                                            selected: "none",
                                            categories: categories
                                        }),
                                        prevArticle && /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_article_suggestion, {
                                            article: prevArticle,
                                            direction: "left"
                                        }),
                                        nextArticle && /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_article_suggestion, {
                                            article: nextArticle,
                                            direction: "right"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Article);


/***/ }),

/***/ 1355:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Ke; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(2351);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(6567);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(2984);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-is-mounted.js
var use_is_mounted = __webpack_require__(4879);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(6723);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(3855);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-server-handoff-complete.js
var use_server_handoff_complete = __webpack_require__(2180);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(3784);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/once.js
function l(r){let e={called:!1};return(...t)=>{if(!e.called)return e.called=!0,r(...t)}}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/disposables.js
var disposables = __webpack_require__(9362);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/transitions/utils/transition.js
function v(t,...e){t&&e.length>0&&t.classList.add(...e)}function f(t,...e){t&&e.length>0&&t.classList.remove(...e)}function F(t,e){let n=(0,disposables/* disposables */.k)();if(!t)return n.dispose;let{transitionDuration:a,transitionDelay:i}=getComputedStyle(t),[m,d]=[a,i].map(o=>{let[r=0]=o.split(",").filter(Boolean).map(l=>l.includes("ms")?parseFloat(l):parseFloat(l)*1e3).sort((l,g)=>g-l);return r});if(m+d!==0){let o=n.addEventListener(t,"transitionend",r=>{r.target===r.currentTarget&&(e(),o())})}else e();return n.add(()=>e()),n.dispose}function M(t,e,n,a){let i=n?"enter":"leave",m=(0,disposables/* disposables */.k)(),d=a!==void 0?l(a):()=>{};i==="enter"&&(t.removeAttribute("hidden"),t.style.display="");let u=(0,match/* match */.E)(i,{enter:()=>e.enter,leave:()=>e.leave}),o=(0,match/* match */.E)(i,{enter:()=>e.enterTo,leave:()=>e.leaveTo}),r=(0,match/* match */.E)(i,{enter:()=>e.enterFrom,leave:()=>e.leaveFrom});return f(t,...e.enter,...e.enterTo,...e.enterFrom,...e.leave,...e.leaveFrom,...e.leaveTo,...e.entered),v(t,...u,...r),m.nextFrame(()=>{f(t,...r),v(t,...o),F(t,()=>(f(t,...u),v(t,...e.entered),d()))}),m.dispose}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-disposables.js
var use_disposables = __webpack_require__(4192);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-transition.js
function use_transition_D({container:i,direction:t,classes:o,onStart:s,onStop:u}){let a=(0,use_is_mounted/* useIsMounted */.t)(),c=(0,use_disposables/* useDisposables */.G)(),r=(0,use_latest_value/* useLatestValue */.E)(t);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{let e=(0,disposables/* disposables */.k)();c.add(e.dispose);let n=i.current;if(!!n&&r.current!=="idle"&&!!a.current)return e.dispose(),s.current(r.current),e.add(M(n,o.current,r.current==="enter",()=>{e.dispose(),u.current(r.current)})),e.dispose},[t])}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(3781);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/class-names.js
var class_names = __webpack_require__(4067);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/env.js
var env = __webpack_require__(7896);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js
function P(i=""){return i.split(" ").filter(e=>e.trim().length>1)}let A=(0,react.createContext)(null);A.displayName="TransitionContext";var ge=(s=>(s.Visible="visible",s.Hidden="hidden",s))(ge||{});function be(){let i=(0,react.useContext)(A);if(i===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return i}function Ee(){let i=(0,react.useContext)(transition_M);if(i===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return i}let transition_M=(0,react.createContext)(null);transition_M.displayName="NestingContext";function I(i){return"children"in i?I(i.children):i.current.filter(({el:e})=>e.current!==null).filter(({state:e})=>e==="visible").length>0}function ne(i,e){let s=(0,use_latest_value/* useLatestValue */.E)(i),n=(0,react.useRef)([]),m=(0,use_is_mounted/* useIsMounted */.t)(),y=(0,use_disposables/* useDisposables */.G)(),b=(0,use_event/* useEvent */.z)((l,r=render/* RenderStrategy.Hidden */.l4.Hidden)=>{let t=n.current.findIndex(({el:o})=>o===l);t!==-1&&((0,match/* match */.E)(r,{[render/* RenderStrategy.Unmount */.l4.Unmount](){n.current.splice(t,1)},[render/* RenderStrategy.Hidden */.l4.Hidden](){n.current[t].state="hidden"}}),y.microTask(()=>{var o;!I(n)&&m.current&&((o=s.current)==null||o.call(s))}))}),E=(0,use_event/* useEvent */.z)(l=>{let r=n.current.find(({el:t})=>t===l);return r?r.state!=="visible"&&(r.state="visible"):n.current.push({el:l,state:"visible"}),()=>b(l,render/* RenderStrategy.Unmount */.l4.Unmount)}),S=(0,react.useRef)([]),u=(0,react.useRef)(Promise.resolve()),p=(0,react.useRef)({enter:[],leave:[],idle:[]}),d=(0,use_event/* useEvent */.z)((l,r,t)=>{S.current.splice(0),e&&(e.chains.current[r]=e.chains.current[r].filter(([o])=>o!==l)),e==null||e.chains.current[r].push([l,new Promise(o=>{S.current.push(o)})]),e==null||e.chains.current[r].push([l,new Promise(o=>{Promise.all(p.current[r].map(([f,a])=>a)).then(()=>o())})]),r==="enter"?u.current=u.current.then(()=>e==null?void 0:e.wait.current).then(()=>t(r)):t(r)}),v=(0,use_event/* useEvent */.z)((l,r,t)=>{Promise.all(p.current[r].splice(0).map(([o,f])=>f)).then(()=>{var o;(o=S.current.shift())==null||o()}).then(()=>t(r))});return (0,react.useMemo)(()=>({children:n,register:E,unregister:b,onStart:d,onStop:v,wait:u,chains:p}),[E,b,n,d,v,p,u])}function Se(){}let xe=["beforeEnter","afterEnter","beforeLeave","afterLeave"];function re(i){var s;let e={};for(let n of xe)e[n]=(s=i[n])!=null?s:Se;return e}function Pe(i){let e=(0,react.useRef)(re(i));return (0,react.useEffect)(()=>{e.current=re(i)},[i]),e}let He="div",ie=render/* Features.RenderStrategy */.AN.RenderStrategy,oe=(0,render/* forwardRefWithAs */.yV)(function(e,s){let{beforeEnter:n,afterEnter:m,beforeLeave:y,afterLeave:b,enter:E,enterFrom:S,enterTo:u,entered:p,leave:d,leaveFrom:v,leaveTo:l,...r}=e,t=(0,react.useRef)(null),o=(0,use_sync_refs/* useSyncRefs */.T)(t,s),f=r.unmount?render/* RenderStrategy.Unmount */.l4.Unmount:render/* RenderStrategy.Hidden */.l4.Hidden,{show:a,appear:x,initial:se}=be(),[h,_]=(0,react.useState)(a?"visible":"hidden"),K=Ee(),{register:D,unregister:V}=K,j=(0,react.useRef)(null);(0,react.useEffect)(()=>D(t),[D,t]),(0,react.useEffect)(()=>{if(f===render/* RenderStrategy.Hidden */.l4.Hidden&&!!t.current){if(a&&h!=="visible"){_("visible");return}return (0,match/* match */.E)(h,{["hidden"]:()=>V(t),["visible"]:()=>D(t)})}},[h,t,D,V,a,f]);let U=(0,use_latest_value/* useLatestValue */.E)({enter:P(E),enterFrom:P(S),enterTo:P(u),entered:P(p),leave:P(d),leaveFrom:P(v),leaveTo:P(l)}),L=Pe({beforeEnter:n,afterEnter:m,beforeLeave:y,afterLeave:b}),k=(0,use_server_handoff_complete/* useServerHandoffComplete */.H)();(0,react.useEffect)(()=>{if(k&&h==="visible"&&t.current===null)throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?")},[t,h,k]);let G=se&&!x,le=(()=>!k||G||j.current===a?"idle":a?"enter":"leave")(),ae=(0,use_event/* useEvent */.z)(C=>(0,match/* match */.E)(C,{enter:()=>L.current.beforeEnter(),leave:()=>L.current.beforeLeave(),idle:()=>{}})),ue=(0,use_event/* useEvent */.z)(C=>(0,match/* match */.E)(C,{enter:()=>L.current.afterEnter(),leave:()=>L.current.afterLeave(),idle:()=>{}})),w=ne(()=>{_("hidden"),V(t)},K);use_transition_D({container:t,classes:U,direction:le,onStart:(0,use_latest_value/* useLatestValue */.E)(C=>{w.onStart(t,C,ae)}),onStop:(0,use_latest_value/* useLatestValue */.E)(C=>{w.onStop(t,C,ue),C==="leave"&&!I(w)&&(_("hidden"),V(t))})}),(0,react.useEffect)(()=>{!G||(f===render/* RenderStrategy.Hidden */.l4.Hidden?j.current=null:j.current=a)},[a,G,h]);let B=r,de={ref:o};return x&&a&&env/* env.isServer */.O.isServer&&(B={...B,className:(0,class_names/* classNames */.A)(r.className,...U.current.enter,...U.current.enterFrom)}),react.createElement(transition_M.Provider,{value:w},react.createElement(open_closed/* OpenClosedProvider */.up,{value:(0,match/* match */.E)(h,{["visible"]:open_closed/* State.Open */.ZM.Open,["hidden"]:open_closed/* State.Closed */.ZM.Closed})},(0,render/* render */.sY)({ourProps:de,theirProps:B,defaultTag:He,features:ie,visible:h==="visible",name:"Transition.Child"})))}),J=(0,render/* forwardRefWithAs */.yV)(function(e,s){let{show:n,appear:m=!1,unmount:y,...b}=e,E=(0,react.useRef)(null),S=(0,use_sync_refs/* useSyncRefs */.T)(E,s);(0,use_server_handoff_complete/* useServerHandoffComplete */.H)();let u=(0,open_closed/* useOpenClosed */.oJ)();if(n===void 0&&u!==null&&(n=(0,match/* match */.E)(u,{[open_closed/* State.Open */.ZM.Open]:!0,[open_closed/* State.Closed */.ZM.Closed]:!1})),![!0,!1].includes(n))throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");let[p,d]=(0,react.useState)(n?"visible":"hidden"),v=ne(()=>{d("hidden")}),[l,r]=(0,react.useState)(!0),t=(0,react.useRef)([n]);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{l!==!1&&t.current[t.current.length-1]!==n&&(t.current.push(n),r(!1))},[t,n]);let o=(0,react.useMemo)(()=>({show:n,appear:m,initial:l}),[n,m,l]);(0,react.useEffect)(()=>{if(n)d("visible");else if(!I(v))d("hidden");else{let a=E.current;if(!a)return;let x=a.getBoundingClientRect();x.x===0&&x.y===0&&x.width===0&&x.height===0&&d("hidden")}},[n,v]);let f={unmount:y};return react.createElement(transition_M.Provider,{value:v},react.createElement(A.Provider,{value:o},(0,render/* render */.sY)({ourProps:{...f,as:react.Fragment,children:react.createElement(oe,{ref:S,...f,...b})},theirProps:{},defaultTag:react.Fragment,features:ie,visible:p==="visible",name:"Transition"})))}),Ne=(0,render/* forwardRefWithAs */.yV)(function(e,s){let n=(0,react.useContext)(A)!==null,m=(0,open_closed/* useOpenClosed */.oJ)()!==null;return react.createElement(react.Fragment,null,!n&&m?react.createElement(J,{ref:s,...e}):react.createElement(oe,{ref:s,...e}))}),Ke=Object.assign(J,{Child:Ne,Root:J});


/***/ }),

/***/ 4192:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ p; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _utils_disposables_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9362);
function p(){let[e]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(_utils_disposables_js__WEBPACK_IMPORTED_MODULE_1__/* .disposables */ .k);return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>()=>e.dispose(),[e]),e}


/***/ }),

/***/ 4879:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ f; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6723);
function f(){let e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);return (0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(()=>(e.current=!0,()=>{e.current=!1}),[]),e}


/***/ }),

/***/ 9362:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ m; }
/* harmony export */ });
/* harmony import */ var _micro_task_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1021);
function m(){let a=[],i=[],r={enqueue(e){i.push(e)},addEventListener(e,t,n,s){return e.addEventListener(t,n,s),r.add(()=>e.removeEventListener(t,n,s))},requestAnimationFrame(...e){let t=requestAnimationFrame(...e);return r.add(()=>cancelAnimationFrame(t))},nextFrame(...e){return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e))},setTimeout(...e){let t=setTimeout(...e);return r.add(()=>clearTimeout(t))},microTask(...e){let t={current:!0};return (0,_micro_task_js__WEBPACK_IMPORTED_MODULE_0__/* .microTask */ .Y)(()=>{t.current&&e[0]()}),r.add(()=>{t.current=!1})},add(e){return a.push(e),()=>{let t=a.indexOf(e);if(t>=0){let[n]=a.splice(t,1);n()}}},dispose(){for(let e of a.splice(0))e()},async workQueue(){for(let e of i.splice(0))await e()},style(e,t,n){let s=e.style.getPropertyValue(t);return Object.assign(e.style,{[t]:n}),this.add(()=>{Object.assign(e.style,{[t]:s})})}};return r}


/***/ }),

/***/ 1021:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ t; }
/* harmony export */ });
function t(e){typeof queueMicrotask=="function"?queueMicrotask(e):Promise.resolve().then(e).catch(o=>setTimeout(()=>{throw o}))}


/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 2222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [396,818,726,774,888,179], function() { return __webpack_exec__(1595); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);